import type { WhatsNewBody } from '../types';

export default {
  title: 'A Subcontractors box beside Temps active',
  summary:
    'The Manpower schedule has a new Subcontractors box next to Temps active. The manpower scheduler types in how many subcontractor workers are on local jobsites now, and like temps they are counted inside Available MP.',
  details: [
    'Temps and subcontractors together can’t be more than Available MP. A save that would go over is refused with the reason.',
    'The box shows when it was last entered, and a dash until it has been.',
  ],
  audience: { label: 'everyone who uses Manpower', test: (a) => !a.fieldLeaderOnly },
  tryIt: { to: '/manpower', label: 'Open Manpower' },
  image: {
    file: 'subcontractors-box.png',
    alt: 'The Crew Schedule’s three boxes: Available MP per day, Temps active, and the new Subcontractors box, each with a figure and the date it was last entered.',
  },
  guide: { topic: 'mp-available-mp' },
} satisfies WhatsNewBody;
